<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      title="Tips"
      :visible.sync="_dialogVisible"
      class="new-dialog dialog-550"
      @close="onCancel"
    >
      <div slot="title">
        <img
          :src="tips2"
          class="new-tips-icon"
          v-if="$route.meta.theme == 'news-theme'"
        />
        <img
          :src="tips3"
          class="new-tips-icon"
          v-else-if="$route.meta.theme == 'sanction-theme'"
        />
        <img :src="tips1" class="new-tips-icon" v-else />
        <div class="center el-dialog__title">Tips</div>
      </div>
      <div class="new-dialog-desc">
        The feature you’re attempting to access is part of our premium
        membership benefits. To gain access to this feature and enjoy full
        access to premium features, please subscribe to our membership plan.
      </div>
      <div slot="footer" class="center new-dialog-footer">
        <!-- <el-button class="cancel new-dialog-footer-btn" @click="onCancel">
          OK
        </el-button> -->
        <el-button class="new-dialog-footer-btn" @click="onConfirm">
          Subscribe
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: { type: Boolean, default: false },
  },
  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      },
    },
  },
  data() {
    return {
      tips1: require("@/assets/images/newPage/tipsBlue.png"),
      tips2: require("@/assets/images/newPage/tipsGreen.png"),
      tips3: require("@/assets/images/newPage/tipsOrange.png"),
    };
  },
  methods: {
    onCancel() {
      this._dialogVisible = false;
    },
    onConfirm() {
      this.$router.push({
        path: "/index/addCredit",
      });
    },
  },
};
</script>

<style scoped>
.new-tips-icon {
  display: block;
  width: 80px;
  height: 70px;
  margin: 0 auto 20px auto;
}
.new-dialog-desc {
  line-height: 32px;
  font-size: 20px;
  color: #1a2332;
  word-break: break-word;
}
.new-dialog >>> .el-dialog__footer {
  padding-top: 30px;
}
.new-dialog-footer .el-button + .el-button {
  margin-left: 30px;
}
@media (max-width: 1439px) {
  .new-tips-icon {
    width: 55px;
    height: 48px;
    margin: 0 auto 14px auto;
  }
  .new-dialog-desc {
    line-height: 22px;
    font-size: 14px;
  }
  .new-dialog >>> .el-dialog__footer {
    padding-top: 20px;
  }
  .new-dialog-footer .el-button + .el-button {
    margin-left: 20px;
  }
}
</style>
